import { once } from './utils';
import list from './supported-sites-list';

const $supportedSites = document.querySelector('.supported-sites');

if ($supportedSites) {
  const $form = $supportedSites.querySelector('.supported-sites__form');
  const $input = $supportedSites.querySelector('.supported-sites__input');
  const $button = $supportedSites.querySelector('.supported-sites__button');
  const $result = $supportedSites.querySelector('.supported-sites__result');
  const $list = $supportedSites.querySelector('.supported-sites__list');
  const $link = document.querySelector('.supported-sites-link');
  const inDialog = !!$supportedSites.closest('.dialog');

  const initList = once(() => {
    $list.innerHTML = list.map((item) => `<li>${item}</li>`).join('');
  });

  const handleSubmit = (event) => {
    event.preventDefault();
  };

  const handleClick = (event) => {
    event.preventDefault();
  };

  const handleInput = () => {
    initList();

    const value = $input.value.trim();

    const regExp = new RegExp(value.replace(/[|\\{}()[\]^$+*?.-]/g, '\\$&'), 'i');
    let hasVisibleItems = false;

    if (value) {
      for (let i = 0; i < $list.children.length; i++) {
        const $item = $list.children[i];

        if (value) {
          $item.hidden = !regExp.test($item.textContent);
        } else if (inDialog) {
          $item.hidden = false;
        }

        hasVisibleItems = hasVisibleItems || !$item.hidden;
      }
    }

    if (!inDialog) {
      $result.classList.toggle('supported-sites__result--visible', hasVisibleItems);
    }
  };

  $form.addEventListener('submit', handleSubmit);
  $button.addEventListener('click', handleClick);
  $input.addEventListener('input', handleInput);

  if ($link) {
    const handleLinkClick = () => {
      initList();
      $link.removeEventListener('click', handleLinkClick);
    };

    $link.addEventListener('click', handleLinkClick);
  }
}
